import { PostWalletRequest } from '@aaa-ncnu-ie/mypolicy-api-billing';
import { AxiosError } from 'axios';

import axios from '../axios';

export const addToWallet = async ({ ownerID, account }: PostWalletRequest) => {
  try {
    if (!ownerID) {
      throw new Error('Missing ownerID');
    }

    const requestBody: PostWalletRequest = {
      ownerID,
      account,
    };

    const { data } = await axios.post<void>(
      `${import.meta.env.VITE_MYPOLICY_BILLING_API_URL}/v1/wallet`,
      requestBody,
      {
        headers: {
          'Content-Type': 'application/json',
          accept: 'application/json',
          'x-api-key': import.meta.env.VITE_X_API_KEY ?? '',
        },
      }
    );

    return data;
  } catch (error) {
    const axiosError = error as AxiosError;
    if (axiosError?.response?.status === 404) {
      return axiosError.response.data;
    }
    return error;
  }
};
